import stringToClassName from 'commons/stringToClassName';

const getTabId = (itemLabel, componentName) =>
  `${componentName ? `${componentName}-` : ''}-${stringToClassName(
    itemLabel
  )}-tab`;

export default getTabId;
